<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [parkourBackButton]="['../..']" />
    </ion-buttons>

    <ion-title>{{ 'team.teamlid-detail-page.title' | translate }}</ion-title>

    <ion-buttons *parkourShowIfSuccessful="mainPageData$ | async; let data" slot="end">
      @if (data.isJongere) {
        <parkour-header-action
          [label]="'team.teamlid-detail-page.teamlid-edit' | translate"
          [link]="['wijzig']"
          icon="edit"
          testId="edit"
        />
      }
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-refresher [parkourRefresh]="onPageRefresh" slot="fixed">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>

  <parkour-page-layout>
    <ng-container *parkourPageContent="mainPageData$ | async; refresh: onPageRefresh; let data">
      @switch (data.teamlid.status) {
        @case ('ACTIEF') {
          <parkour-profiel-details [profiel]="data.teamlid">
            <p class="text-n-600" data-testid="rol" typeContent>
              {{ data.teamlid.rol | rolLabel }}
            </p>
            <ng-container topCardContent>
              @if (data.teamlid.verificatieStatus === 'GEVERIFIEERD') {
                <parkour-profiel-details-geverifieerd-card />
              }
              <parkour-profiel-details-afwezigheid-card [afwezigheid]="data.teamlid.afwezigheid" />
            </ng-container>
          </parkour-profiel-details>
        }
        @case ('GEBLOKKEERD') {
          <parkour-page-with-gradient-hero [title]="data.teamlid | profielnaam">
            <parkour-profiel-foto class="block" hero-image [profiel]="data.teamlid" [size]="'10'" />
            @if (data.isJongere) {
              <parkour-info-card>
                Je kan de profielgegevens niet zien omdat deze persoon geblokkeerd is.
              </parkour-info-card>

              <div>
                <h2 class="typo-h3">Delen</h2>

                <parkour-deel-details-list
                  [blocked]="data.teamlid.status === 'GEBLOKKEERD'"
                  class="block mt-5"
                />
              </div>
            } @else {
              <parkour-info-card>
                Je kan de profielgegevens niet zien omdat deze persoon geblokkeerd is door de
                teameigenaar.
              </parkour-info-card>
            }
          </parkour-page-with-gradient-hero>
        }
      }
    </ng-container>
  </parkour-page-layout>
</ion-content>
